<template>
  <modal
    class="editFaultModal"
    name="editFault"
    transition="pop-out"
    :width="650"
    :height="600"
  >
    <div class="modal__header">
      <span class="mr-3"
        ><img src="@/assets/img/building (1).svg" width="50" height="60"
      /></span>
      <h4>{{ $t("text.editFaultModal.title") }}</h4>
    </div>
    <div>
      <fieldset
        class="border p-3 form-group mt-3"
        style="margin: 0 auto; width: 85%"
      >
        <legend
          class="w-auto"
          style="color: #7d7885; font-size: 16px; padding: 10px"
        >
          Branch Monthly Sales Target
        </legend>

        <div
          class="input__group__block mt-4"
          style="margin: 0 auto; width: 50%"
        >
          <label class="required">
            {{ $t("text.editFaultModal.target") }}
          </label>
          <div class="input__block" ref="target_input_div">
            <input
              style="padding: 20px; width: 100%"
              type="number"
              :placeholder="$t('text.editFaultModal.inputTarget')"
              @blur="captureFormEvents($event)"
            />
          </div>

          <div ref="target_error"></div>
        </div>
        <div class="text-center py-3 mt-3">
          <button
            class="sales_target_btn text-center"
            @click="updateTarget($event)"
            :disabled="isButtonDisabled ? true : null"
            :style="[
              isButtonDisabled
                ? { cursor: 'not-allowed' }
                : { cursor: 'pointer' },
            ]"
          >
            {{ $t("text.editFaultModal.updateTarget") }}<span></span>
          </button>
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="35px"
            class="ml-3 loader"
          />
        </div>
      </fieldset>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 850;
import configObject from "@/config";

export default {
  name: "editFault",
  props: ["fault"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      product: null,
      target: null,
      prodArray: [],
      prodList: [],
      isButtonDisabled: false,
      pmsPrice: 0,
      agoPrice: 0,
      dpkPrice: 0,
      price: 0,
    };
  },
  mounted() {
    if (this.branch !== null) {
      this.branchId = this.branch.id;
    }
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;

    this.branch = localStorage.getItem("branchDetails")
      ? JSON.parse(localStorage.getItem("branchDetails"))
      : null;
  },
  methods: {},
};
</script>
